// ==================== ROUTE CONSTANTS ====================

export const ROUTES = {
  // Public Routes
  HOME: '/',
  ABOUT: '/about',
  FEATURES: '/features',
  PRICING: '/pricing',
  CONTACT: '/contact',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  WHITEPAPERS: '/whitepapers',

  // Auth Routes
  AUTH: {
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    VERIFY_EMAIL: '/verify-email',
  },
  
  // Dashboard Routes (Role-based)
  DASHBOARD: {
    ROOT: '/dashboard',
    OVERVIEW: '/dashboard/overview',
  },
  
  // Super Admin Routes
  ADMIN: {
    ROOT: '/admin',
    DASHBOARD: '/admin/dashboard',
    CUSTOMERS: '/admin/customers',
    CUSTOMER_DETAIL: '/admin/customers/:id',
    SUBSCRIPTION_PLANS: '/admin/plans',
    SUBSCRIPTIONS: '/admin/subscriptions',
    SETTINGS: '/admin/settings',
  },
  
  // Customer Routes
  CUSTOMER: {
    ROOT: '/app',
    DASHBOARD: '/app/dashboard',
    ORGANIZATION: '/app/organization',
    WHATSAPP: '/app/whatsapp',
    CONTACTS: '/app/contacts',
    CAMPAIGNS: '/app/campaigns',
    CAMPAIGN_DETAIL: '/app/campaigns/:id',
    CAMPAIGN_ANALYTICS: '/app/campaigns/:id/analytics',
    TEMPLATES: '/app/templates',
    SMS_TEMPLATES: '/app/sms-templates',
    MESSAGES: '/app/messages',
    KEYWORD_BOTS: '/app/keyword-bots',
    CHAT: '/app/chat',
    SETTINGS: '/app/settings',
    SETTINGS_PROFILE: '/app/settings/profile',
    SETTINGS_ORGANIZATION: '/app/settings/organization',
    SETTINGS_BILLING: '/app/settings/billing',
    SETTINGS_PAYMENT_METHODS: '/app/settings/payment-methods',
    SETTINGS_PAYMENT_HISTORY: '/app/settings/payments',
    SETTINGS_WHATSAPP: '/app/settings/whatsapp',
    SETTINGS_SMS: '/app/settings/sms',
    SETTINGS_CUSTOM_FIELDS: '/app/settings/custom-fields',
    SMS_MESSAGES: '/app/sms-messages',
    GROUPS: '/app/groups',
    BILLING: '/app/billing',
    UPGRADE_PLAN: '/app/upgrade-plan',
    // Lead Generation Routes
    LEAD_GEN_DASHBOARD: '/app/lead-gen/dashboard',
    LEAD_GEN_DISCOVERY: '/app/lead-gen/discovery',
    LEAD_GEN_NEW_CAMPAIGN: '/app/lead-gen/discovery/new',
    LEAD_GEN_PIPELINE: '/app/lead-gen/pipeline',
    LEAD_GEN_OUTREACH: '/app/lead-gen/outreach',
    LEAD_GEN_MEETINGS: '/app/lead-gen/meetings',
    LEAD_GEN_REPORTS: '/app/lead-gen/reports',
    LEAD_GEN_SETTINGS: '/app/lead-gen/agent-settings',
  },
  
  // Error Routes
  NOT_FOUND: '/404',
  UNAUTHORIZED: '/401',
  FORBIDDEN: '/403',
  SERVER_ERROR: '/500',
} as const;

// Route helpers
export const getCustomerRoute = (path: string): string => `${ROUTES.CUSTOMER.ROOT}${path}`;
export const getAdminRoute = (path: string): string => `${ROUTES.ADMIN.ROOT}${path}`;

// Protected route patterns
export const PROTECTED_PATTERNS = {
  ADMIN: /^\/admin/,
  CUSTOMER: /^\/app/,
  DASHBOARD: /^\/dashboard/,
};

